export const s3Url =
  process.env.NODE_ENV === "production"
    ? "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/diy-kitten-web/images"
    : "/images";
